<div class="fixed-height-1000" *ngIf="producerView;else simpleView">
  <div class="row background m-1 p-1 corners font-weight-bold">
    <div class="col-sm-8">
      <h5>TOTAL ACHATS</h5>
    </div>
    <div class="col-sm-2 text-end">
      <h5>Brut&nbsp;: {{ totalBrutPrice.toFixed(2) }}&nbsp;€</h5>
    </div>
    <div class="col-sm-2 text-end">
      <h5>Net&nbsp;: {{ totalNetPrice.toFixed(2) }}&nbsp;€</h5>
    </div>
  </div>
  <div class="row col-sm-12">
    <div class="row background m-1 p-1 corners font-weight-bold">
      <div class="col-sm-8">
        <h5>CONTRATS</h5>
      </div>
      <div class="col-sm-2 text-end">
        <h5>Brut&nbsp;: {{ contractAndMealBrutPrice }}&nbsp;€</h5>
      </div>
      <div class="col-sm-2 text-end">
        <h5>Net&nbsp;: {{ contractAndMealNetPrice }}&nbsp;€</h5>
      </div>
    </div>
    <table class="table table-striped">
      <thead>
        <tr>
          <th>Type</th>
          <th>Catégorie</th>
          <th>Statut</th>
          <th>Source</th>
          <th>Référence</th>
          <th>Nom</th>
          <th></th>
          <th></th>
          <th>Qté</th>
          <th>ADT</th>
          <th>CHD</th>
          <th>BEBE</th>
          <th></th>
          <th>Total</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let room of effectiveAccommodationRecord?.rooms">
          <td>
            <span style="font-size: small">{{ room.propertyName ? (room.propertyName + ' - ') : '' }}{{ room.type
              }}</span>
          </td>
          <td>
            <span style="font-size: small">{{ room.category | AccommodationRecordRoomCategoryPipe }}</span>
          </td>
          <td>
            <span [class.green-colored]="room.status === BookingSubStatusEnum.OK"
              [class.red-colored]="room.status === BookingSubStatusEnum.KO"
              [class.orange-colored]="room.status === BookingSubStatusEnum.NO">{{ room.status }}</span>
          </td>
          <td>
            {{ room.accommodationProvider !== 'PULPO' ? room.accommodationProvider : 'PULPO' }}
          </td>
          <td>
            <span style="font-size: small">{{ room.accommodationProvider !== 'PULPO' ? room.externalBookingId : '-'
              }}</span>
          </td>
          <td>
            <span style="font-size: small">{{ bookingRecord.productRecord?.contractName }}</span>
          </td>
          <td></td>
          <td></td>
          <td>{{ 1 }}</td>
          <td>{{ room.adult }}</td>
          <td>{{ room.child }}</td>
          <td>{{ room.baby }}</td>
          <td></td>
          <td>{{ room.price.toFixed(2) }}&nbsp;€</td>
        </tr>

        <tr *ngFor="let meal of bookingRecord.mealRecords">
          <td>
            <span style="font-size: small">{{
              meal?.name
              }}</span>
          </td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td>{{ bookingRecord.travelerRecord.adultNumber }}</td>
          <td>{{ bookingRecord.travelerRecord.childNumber }}</td>
          <td>{{ bookingRecord.travelerRecord.babyNumber }} </td>
          <td></td>
          <td></td>
          <td>
            <ng-container *ngIf="meal.price && meal.price !== 0">{{
              meal.price?.toFixed(2) + '&nbsp;€'
              }}</ng-container>
            <ng-container *ngIf="!meal.price || meal.price === 0">inclus</ng-container>
          </td>

        </tr>
      </tbody>
    </table>
  </div>
  <div class="row col-sm-12" *ngIf="effectiveFlightRecord && effectiveFlightRecord.offer">
    <div class="row background m-1 p-1 corners font-weight-bold">
      <div class="col-sm-8">
        <h5>VOLS</h5>
      </div>
      <div class="col-sm-2 text-end">
        <h5>Brut&nbsp;: {{ flightBrutPrice }}&nbsp;€</h5>
      </div>
      <div class="col-sm-2 text-end">
        <h5>Net&nbsp;: {{ flightNetPrice }}&nbsp;€</h5>
      </div>
    </div>
    <table class="table table-striped">
      <thead>
        <tr>
          <th>Source</th>
          <th>Référence</th>
          <th>Réf. Pulpo</th>
          <th *ngIf="effectiveFlightRecord.ticketReference">Ticket</th>
          <th>Statut</th>
          <th>Vols TTC</th>
          <th>Bagages</th>
          <th></th>
          <th>Emis</th>
          <th>Mode</th>
          <th>Total HT</th>
          <th>Taxes</th>
          <th>Total</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>
            {{
            effectiveFlightRecord.source || '-'
            }}
          </td>
          <td>{{ effectiveFlightRecord.supplierLocatorCode }} / {{ effectiveFlightRecord.locatorCode }}</td>
          <td>{{ effectiveFlightRecord.flightInternalReference }}</td>
          <td *ngIf="effectiveFlightRecord.ticketReference">
            {{ effectiveFlightRecord.ticketReference }}
          </td>
          <td>
            <span [class.green-colored]="effectiveFlightRecord.status === 'OK'"
              [class.orange-colored]="effectiveFlightRecord.status === 'NO'"
              [class.red-colored]="effectiveFlightRecord.status === 'KO'">{{ effectiveFlightRecord.status
              }}</span>
          </td>
          <td>{{ getRealFlightPrice(false) }}&nbsp;€</td>
          <td>{{ (effectiveBp.paidLuggagePrice ||
            effectiveFlightRecord.offer.bagRealPrice)?.toFixed(2) || '-' }}&nbsp;€</td>
          <td></td>
          <td>{{ bookingRecord.creationDate | date: 'dd/MM/yyyy' }}</td>
          <td>
            {{ effectiveFlightRecord.offer.paymentMode
            ? effectiveFlightRecord.offer.paymentMode
            : '-'
            }}
          </td>
          <td>{{ effectiveBp.untaxedFlightPackage?.toFixed(2) ?? '0.00' }}&nbsp;€</td>
          <td>
            {{(effectiveBp.taxPrice === null
            ? (Number(effectiveFlightRecord.offer.total) - Number(effectiveFlightRecord.offer.base) -
            (effectiveFlightRecord.offer.bagRealPrice ?
            Number(effectiveFlightRecord.offer.bagRealPrice) : 0)).toFixed(2)
            : Number(effectiveBp.taxPrice).toFixed(2)) + ''
            || '-'
            }}&nbsp;€
          </td>
          <td>{{ getRealFlightPrice(true) }}&nbsp;€</td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="row col-sm-12" *ngIf="effectiveInsuranceRecord">
    <div class="row background m-1 p-1 corners font-weight-bold">
      <div class="col-sm-8">
        <h5>ASSURANCES</h5>
      </div>
      <div class="col-sm-2 text-end">
        <h5>Brut&nbsp;: {{ insuranceBrutPrice }}&nbsp;€</h5>
      </div>
      <div class="col-sm-2 text-end">
        <h5>Net&nbsp;: {{ insuranceNetPrice }}&nbsp;€</h5>
      </div>
    </div>
    <table class="table table-striped">
      <thead>
        <tr>
          <th>Source</th>
          <th>Informations</th>
          <th>Référence</th>
          <th>Réf. Pulpo</th>
          <th></th>
          <th>Statut</th>
          <th>Date</th>
          <th>ADT</th>
          <th>CHD</th>
          <th>BEBE</th>
          <th></th>
          <th>Total</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>
            {{effectiveInsuranceRecord.insuranceName}}
          </td>
          <td>
            {{effectiveInsuranceRecord.insuranceTypeName}}
          </td>
          <td>
            {{effectiveInsuranceRecord.insuranceConnectorRef}}
          </td>
          <td>
            {{effectiveInsuranceRecord.internalReference}}
          </td>
          <td></td>
          <td>
            <span [class.green-colored]="effectiveInsuranceRecord.status === 'OK'"
              [class.orange-colored]="effectiveInsuranceRecord.status === 'NO'"
              [class.red-colored]="effectiveInsuranceRecord.status === 'KO'">{{
              effectiveInsuranceRecord.status }}</span>
          </td>
          <td>
            {{ effectiveInsuranceRecord.insuranceConnectorTimeStamp | date: 'dd/MM/yyyy' }}
          </td>
          <td>{{ bookingRecord.travelerRecord.adultNumber }}</td>
          <td>{{ bookingRecord.travelerRecord.childNumber }}</td>
          <td>{{ bookingRecord.travelerRecord.babyNumber }}</td>
          <td></td>
          <td>{{ effectiveInsuranceRecord.insuranceConnectorPrice ? (
            (parseFloat(effectiveInsuranceRecord.insuranceConnectorPrice)).toFixed(2)) : 0 }}&nbsp;€
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="row col-sm-12" *ngIf="bookingRecord.carRentalRecord">
    <div class="row background m-1 p-1 corners font-weight-bold">
      <div class="col-sm-8">
        <h5>LOCATIONS DE VOITURE</h5>
      </div>
      <div class="col-sm-2 text-end">
        <h5>Brut&nbsp;: {{ vehicleBrutPrice }}&nbsp;€</h5>
      </div>
      <div class="col-sm-2 text-end">
        <h5>Net&nbsp;: {{ vehicleNetPrice }}&nbsp;€</h5>
      </div>
    </div>
    <table class="table table-striped">
      <thead>
        <tr>
          <th>Source</th>
          <th>ID</th>
          <th></th>
          <th>Référence</th>
          <th>Catégorie</th>
          <th></th>
          <th>Statut</th>
          <th></th>
          <th>ADT</th>
          <th>CHD</th>
          <th>BEBE</th>
          <th></th>
          <th>Base</th>
          <th>Supplément</th>
          <th>Commission</th>
          <th>Total</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>{{ bookingRecord.carRentalRecord.carRentalProvider }}</td>
          <td>{{ bookingRecord.carRentalRecord.carRentalOfferToken }}</td>
          <td></td>
          <td>{{ bookingRecord.carRentalRecord.carRentalBookingReference }}</td>
          <td>{{ bookingRecord.carRentalRecord.carRentalCategory }}</td>
          <td></td>
          <td>
            <span [class.green-colored]="bookingRecord.carRentalRecord.status === 'OK'"
              [class.red-colored]="bookingRecord.carRentalRecord.status !== 'OK'">{{
              bookingRecord.carRentalRecord.status }}</span>
          </td>
          <td></td>
          <td>{{ bookingRecord.travelerRecord.adultNumber }}</td>
          <td>{{ bookingRecord.travelerRecord.childNumber }}</td>
          <td>{{ bookingRecord.travelerRecord.babyNumber }}</td>
          <td></td>
          <td>{{bookingRecord.carRentalRecord.carRentalReferencePrice}}&nbsp;€</td>
          <td>{{bookingRecord.carRentalRecord.carRentalSupplement}}&nbsp;€</td>
          <td>{{bookingRecord.carRentalRecord.carRentalCommission}}&nbsp;€</td>
          <td>{{bookingRecord.carRentalRecord.carRentalOfferPrice ||
            (bookingRecord.carRentalRecord.carRentalReferencePrice +
            bookingRecord.carRentalRecord.carRentalSupplement)}}&nbsp;€</td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="row col-sm-12" *ngIf="effectiveOptionRecord">
    <div class="row background m-1 p-1 corners font-weight-bold">
      <div class="col-sm-8">
        <h5>OPTIONS</h5>
      </div>
      <div class="col-sm-2 text-end">
        <h5>Brut&nbsp;: {{ optionBrutPrice }}&nbsp;€</h5>
      </div>
      <div class="col-sm-2 text-end">
        <h5>Net&nbsp;: {{ optionNetPrice }}&nbsp;€</h5>
      </div>
    </div>
    <table class="table table-striped">
      <thead>
        <tr>
          <th>Référence</th>
          <th>ID</th>
          <th>Statut</th>
          <th>Source</th>
          <th>Type</th>
          <th>Lieu</th>
          <th></th>
          <th>Qté</th>
          <th>ADT</th>
          <th>CHD</th>
          <th>BEBE</th>
          <th></th>
          <th>Total</th>
        </tr>
      </thead>
      <tbody></tbody>
      <tbody *ngFor="let option of effectiveOptionRecord.options || []; let i = index">
        <tr *ngIf="option.base === TypeBaseEnum.UNIT">
          <td>
            <span style="font-size: small" [matTooltip]=" option.name ">{{option.name | ShortTextPipe:'10'}}</span>
          </td>
          <td>{{ option.name }}</td>
          <td>OK</td>
          <td>{{ option.provider }}</td>
          <td>{{ option.optionType }}</td>
          <td>{{ option.location }}</td>
          <td></td>
          <td>{{ option.nbUnits}}</td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td *ngIf="option.name">
            <ng-container *ngIf="!option.mandatory">
              {{ option.totalPrice?.toFixed(2) }}&nbsp;€
            </ng-container>
            <ng-container *ngIf="option.mandatory">
              inclus
            </ng-container>
          </td>
        </tr>
        <tr *ngIf="option.base === TypeBaseEnum.PERSON">
          <td>
            <span style="font-size: small" [matTooltip]=" option.name ">{{option.name | ShortTextPipe:'10'}}</span>
          </td>
          <td>{{ option.name }}</td>
          <td>OK</td>
          <td>{{ option.provider }}</td>
          <td>{{ option.optionType }}</td>
          <td>{{ option.location }}</td>
          <td></td>
          <td></td>
          <td>{{ option.nbAdults }}</td>
          <td>{{ option.nbChildren }}</td>
          <td></td>
          <td></td>
          <td *ngIf="option.name">
            <ng-container *ngIf="!option.mandatory">
              {{ option.totalPrice?.toFixed(2) }}&nbsp;€
            </ng-container>
            <ng-container *ngIf="option.mandatory">
              inclus
            </ng-container>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<ng-template #simpleView>
  <table class="table w-100 h-100">
    <thead>
      <tr>
        <th>Détails</th>
        <th></th>
        <th>Qté</th>
        <th>ADT</th>
        <th>CHD</th>
        <th>BB</th>
        <th></th>
        <th>Com</th>
        <th>Montant</th>
      </tr>
    </thead>
    <tbody *ngIf="effectiveAccommodationRecord?.rooms" style="border-radius: 10px;">
      <tr class="background">
        <td><span style="font-weight: bold"> FORFAIT </span></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td> <span style="font-size: small">
            {{effectiveBp.packageCommission?.toFixed(2) ?? '0.00'}}&nbsp;€ </span></td>
        <td> <span> {{effectiveBp.packagePrice?.toFixed(2) ?? '0.00'}}&nbsp;€ </span> </td>
      </tr>
    </tbody>
    <tbody *ngIf="effectiveAccommodationRecord?.rooms">
      <tr class="background corners">
        <td><span class="font-italic"> Hébergement </span> </td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
      </tr>
    </tbody>
    <tbody *ngFor="let room of effectiveAccommodationRecord?.rooms || [];  let i = index">
      <tr>
        <td><span style="font-size: small" [matTooltip]="room.type">{{ room.propertyName ? (room.propertyName + ' - ') :
            ''
            }}{{room.type | ShortTextPipe:'10'}}</span></td>
        <td><span style="font-size: small">{{room.category || ''}}</span></td>
        <td>{{1}}</td>
        <td>{{room.adult}}</td>
        <td>{{room.child}}</td>
        <td>{{room.baby}}</td>
        <td></td>
        <td></td>
        <td></td>
      </tr>
    </tbody>
    <tbody *ngFor="let meal of bookingRecord.mealRecords || [];  let i = index">
      <tr>
        <td><span style="font-size: small">{{meal.name}}</span></td>
        <td></td>
        <td>{{bookingRecord.travelerRecord.adultNumber + bookingRecord.travelerRecord.childNumber +
          bookingRecord.travelerRecord.babyNumber}}</td>
        <td>{{bookingRecord.travelerRecord.adultNumber}}</td>
        <td>{{bookingRecord.travelerRecord.childNumber}}</td>
        <td>{{bookingRecord.travelerRecord.babyNumber}}</td>
        <td></td>
        <td> </td>
        <td> <span><ng-container *ngIf="meal.price && meal.price !== 0">{{
              meal.price?.toFixed(2) + '&nbsp;€'
              }}</ng-container>
            <ng-container *ngIf="!meal.price || meal.price === 0">inclus</ng-container></span></td>
      </tr>
    </tbody>
    <tbody *ngIf="effectiveFlightRecord">
      <tr class="background corners">
        <td> <span class="font-italic"> Transport </span></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
      </tr>
    </tbody>
    <tbody *ngIf="effectiveFlightRecord">
      <tr>
        <td><span style="font-size: small"> Vols </span></td>
        <td></td>
        <td>{{bookingRecord.travelerRecord.adultNumber + bookingRecord.travelerRecord.childNumber +
          bookingRecord.travelerRecord.babyNumber}}</td>
        <td>{{bookingRecord.travelerRecord.adultNumber}}</td>
        <td>{{bookingRecord.travelerRecord.childNumber}}</td>
        <td>{{bookingRecord.travelerRecord.babyNumber}}</td>
        <td></td>
        <td></td>
        <td> <span>Inclus </span> </td>
      </tr>
    </tbody>
    <tbody *ngIf="effectiveFlightRecord">
      <tr>
        <td><span style="font-size: small"> Taxes </span></td>
        <td></td>
        <td>{{bookingRecord.travelerRecord.adultNumber + bookingRecord.travelerRecord.childNumber +
          bookingRecord.travelerRecord.babyNumber}}</td>
        <td>{{bookingRecord.travelerRecord.adultNumber}}</td>
        <td>{{bookingRecord.travelerRecord.childNumber}}</td>
        <td>{{bookingRecord.travelerRecord.babyNumber}}</td>
        <td></td>
        <td></td>
        <td><span>{{effectiveBp.taxPrice?.toFixed(2) ?? '0.00'}} €</span></td>
      </tr>
    </tbody>
    <tbody *ngIf="hasLuggage()">
      <tr>
        <td><span style="font-size: small"> Bagages </span></td>
        <td></td>
        <td>{{getTotalLuggage()}}</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td><span style="font-size: small">
            {{effectiveBp.totalLuggageCommission?.toFixed(2) ?? '0.00'}} € </span></td>
        <td><span> {{effectiveBp.luggagePrice?.toFixed(2) ?? '0.00'}} € </span></td>
      </tr>
    </tbody>
    <tbody *ngIf="(effectiveOptionRecord?.options?.length || 0) > 0">
      <tr class="background corners">
        <td> <span class="font-italic"> Options </span></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
      </tr>
    </tbody>
    <tbody *ngFor="let option of effectiveOptionRecord?.options || [];  let i = index">
      <tr *ngIf="option.base === TypeBaseEnum.UNIT">
        <td>
          <span style="font-size: small" [matTooltip]=" option.name ">{{option.name | ShortTextPipe:'10'}}</span>
        </td>
        <td></td>
        <td>{{ option.nbUnits}}</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td>
          <ng-container *ngIf="!option.mandatory">
            <span style="font-size: small">
              {{ option.commission?.toFixed(2) }} € </span>
          </ng-container>
        </td>
        <td><ng-container *ngIf="!option.mandatory"><span> {{(option.margedTotalPrice ??
              option.totalPrice)?.toFixed(2)}} €</span></ng-container>
          <ng-container *ngIf="option.mandatory"><span> inclus</span></ng-container>
        </td>
      </tr>
      <tr *ngIf="option.base === TypeBaseEnum.PERSON">
        <td>
          <span style="font-size: small" [matTooltip]=" option.name ">{{option.name | ShortTextPipe:'10'}}</span>
        </td>
        <td></td>
        <td></td>
        <td>{{option.nbAdults || ''}}</td>
        <td>{{option.nbChildren || ''}}</td>
        <td></td>
        <td></td>
        <td>
          <ng-container *ngIf="!option.mandatory">
            <span style="font-size: small">
              {{ option.commission?.toFixed(2) }} € </span>
          </ng-container>
        </td>
        <td><ng-container *ngIf="!option.mandatory"><span> {{(option.margedTotalPrice ??
              option.totalPrice)?.toFixed(2)}} €</span></ng-container>
          <ng-container *ngIf="option.mandatory"><span> inclus</span></ng-container>
        </td>
      </tr>
    </tbody>
    <tbody *ngIf="effectiveInsuranceRecord">
      <tr class="background corners">
        <td><span class="font-italic">Assurances </span></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
      </tr>
    </tbody>
    <tbody *ngIf="effectiveInsuranceRecord">
      <tr>
        <td><span style="font-size: small">{{effectiveInsuranceRecord.insuranceName}}</span></td>
        <td><span style="font-size: small"
            [matTooltip]="effectiveInsuranceRecord.insuranceTypeName">{{effectiveInsuranceRecord.insuranceTypeName
            | ShortTextPipe:'10'}}</span></td>
        <td></td>
        <td>{{bookingRecord.travelerRecord.adultNumber}}</td>
        <td>{{bookingRecord.travelerRecord.childNumber}}</td>
        <td>{{bookingRecord.travelerRecord.babyNumber}}</td>
        <td></td>
        <td><span style="font-size: small">
            {{effectiveBp.totalInsuranceCommission?.toFixed(2) ?? '0.00'}} € </span></td>
        <td><span>{{effectiveBp.insurancePrice?.toFixed(2) ?? '0.00'}} €</span></td>
      </tr>
    </tbody>

    <tbody *ngIf="bookingRecord.carRentalRecord">
      <tr class="background corners">
        <td><span class="font-italic">Locations de voiture </span></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
      </tr>
    </tbody>
    <tbody *ngIf="bookingRecord.carRentalRecord">
      <tr>
        <td><span style="font-size: small">{{bookingRecord.carRentalRecord.carRentalProvider}}</span></td>
        <td><span style="font-size: small"
            [matTooltip]="bookingRecord.carRentalRecord.carRentalName">{{bookingRecord.carRentalRecord.carRentalName |
            ShortTextPipe:'10'}}</span></td>
        <td></td>
        <td>{{bookingRecord.travelerRecord.adultNumber}}</td>
        <td>{{bookingRecord.travelerRecord.childNumber}}</td>
        <td>{{bookingRecord.travelerRecord.babyNumber}}</td>
        <td></td>
        <td>
          <span style="font-size: small">{{ vehicleCommission }} €</span>
        </td>
        <td>
          @if(vehicleClientPrice) {
          <span>{{ vehicleClientPrice }}</span>
          } @else {
          <span> inclus</span>
          }
        </td>
      </tr>
    </tbody>
  </table>
  <div class="row w-100">
    <div class="col-sm-6">
    </div>
    <div class="col-sm-6">
      <table class="w-100">
        <tbody class="w-100 background corners">
          <tr>
            <td>
              <h5>TOTAL</h5>
            </td>
            <td></td>
            <td></td>
            <td>
              <h5 class="font-weight-bold">{{effectiveBp.totalPrice?.toFixed(2) ?? '0.00'}}&nbsp;€</h5>
            </td>
          </tr>
        </tbody>
        <tbody class="w-100">
          <tr *ngIf="effectiveBp.commissionPercent && effectiveBp.totalCommission">
            <td><span class="font-italic">Commission</span></td>
            <td><span class="font-italic"></span></td>
            <td><span class="font-italic"></span></td>
            <td><span>{{effectiveBp.totalCommission?.toFixed(2) ?? '0.00'}}&nbsp;€</span></td>
          </tr>
        </tbody>
        <tbody class="w-100 background corners">
          <tr *ngIf="effectiveBp.commissionPercent && effectiveBp.totalCommission">
            <td>
              <h5>A PAYER</h5>
            </td>
            <td></td>
            <td></td>
            <td>
              <h5 class="font-weight-bold">{{((effectiveBp.totalPrice ?? 0) -
                effectiveBp.totalCommission).toFixed(2)}}&nbsp;€</h5>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</ng-template>